// user UUIDs for stream and coupon feature
export const COUPON_STREAM_WHITELISTED_USERS = [
	'05bd2522-2f6e-42ac-9277-f1d4e4478952', // Nicholas
	'0c1d7af3-8601-484c-b651-7ca31d119607', // Trish
	'7e486802-3d29-4614-9a59-49a7e4ca41e0', // Aimee
	'67eaf692-3151-49e3-959d-75a74932dd58', // Aimee's User UUID
	'eddea4dc-aea9-4f48-968e-0f2cff4a4aca', // Alex
	'77007fa3-93b9-4edb-8953-202900243334', // Big Al
	'cdd562a6-5b22-47aa-b8c2-e4b78bb7f951', // Linda
	'e63155e3-8ba3-466a-956c-7c7d884698e9', // Chaleen
	'f92cb643-f63f-41f4-bb07-b0bfd9cf128d', // Kylie
	'e8928aef-bb40-4487-8795-aca3bee8ae11', // Barry
	'90c9d083-46cd-4cef-91b3-f148b41e9200', // Geoffery
	'862433d7-56f9-4205-91c6-d9ec2341bd38', // Emilie
	'b3a0d569-b80c-4d82-8c36-402c65e7149d', // Matt
	'8d5d3c38-0bd3-4e75-913a-13c73bb15e46', // Gayle
	'818353b5-c80c-4a37-9749-3f99cae02620', // Tegan
	'db6362f2-241a-4c61-a1e9-8ce51a072ea8', // Sharon
	'919e3c18-e783-403b-b40a-f4e3bfd20716', // Yael
	'd854c3e0-d783-4702-8d5e-86c9f2160a81', // Mike
	'b9733ef8-12b9-4660-9cb7-f9356ac0d53c', // Tracy
	'36eb3ad8-1cc3-44d5-8ace-df3d381abbe7', // Glenda
	'90a36b1c-0402-4921-95b4-9de0de9ec0e2', // John
	'b3a9aaf8-46c5-4cc6-be98-bf34a1bc850b', //Jan
	'83216b8f-14e9-4f09-a903-601e9a74e184', // nics test account
	'8ea27b99-711b-40f9-b1a4-26f14e97d097', // Umang
	'43a2e9b5-f64b-407e-a388-4fd02550f872', // Ray
	'2f7066f4-6544-4229-9032-72c422fa9885', // Simon's User UUID - Dev
	'2f7066f4-6544-4229-9032-72c422fa9100', // Umang's user UUID - Dev
	'2f7066f4-6544-4229-9032-72c422fa9101' // Test's user UUID -Dev
];

// user UUIDs for stream and coupon feature
export const STREAM_WHITELISTED_USERS = [
	'05bd2522-2f6e-42ac-9277-f1d4e4478952', // Nicholas
	'0c1d7af3-8601-484c-b651-7ca31d119607', // Trish
	'7e486802-3d29-4614-9a59-49a7e4ca41e0', // Aimee
	'67eaf692-3151-49e3-959d-75a74932dd58', // Aimee's User UUID
	'eddea4dc-aea9-4f48-968e-0f2cff4a4aca', // Alex
	'77007fa3-93b9-4edb-8953-202900243334', // Big Al
	'cdd562a6-5b22-47aa-b8c2-e4b78bb7f951', // Linda
	'e63155e3-8ba3-466a-956c-7c7d884698e9', // Chaleen
	'f92cb643-f63f-41f4-bb07-b0bfd9cf128d', // Kylie
	'e8928aef-bb40-4487-8795-aca3bee8ae11', // Barry
	'90c9d083-46cd-4cef-91b3-f148b41e9200', // Geoffery
	'862433d7-56f9-4205-91c6-d9ec2341bd38', // Emilie
	'b3a0d569-b80c-4d82-8c36-402c65e7149d', // Matt
	'8d5d3c38-0bd3-4e75-913a-13c73bb15e46', // Gayle
	'818353b5-c80c-4a37-9749-3f99cae02620', // Tegan
	'db6362f2-241a-4c61-a1e9-8ce51a072ea8', // Sharon
	'919e3c18-e783-403b-b40a-f4e3bfd20716', // Yael
	'd854c3e0-d783-4702-8d5e-86c9f2160a81', // Mike
	'b9733ef8-12b9-4660-9cb7-f9356ac0d53c', // Tracy
	'36eb3ad8-1cc3-44d5-8ace-df3d381abbe7', // Glenda
	'90a36b1c-0402-4921-95b4-9de0de9ec0e2', // John
	'b3a9aaf8-46c5-4cc6-be98-bf34a1bc850b', //Jan
	'83216b8f-14e9-4f09-a903-601e9a74e184', // nics test account
	'8ea27b99-711b-40f9-b1a4-26f14e97d097', // Umang
	'43a2e9b5-f64b-407e-a388-4fd02550f872', // Ray
	'2f7066f4-6544-4229-9032-72c422fa9885', // Simon's User UUID - Dev
	'2f7066f4-6544-4229-9032-72c422fa9100' // Umang's user UUID - Dev
];



// WEBPACK FOOTER //
// ./src/betaFeatureWhiteList.js